module.exports = __webpack_public_path__ + "static/devil_triangle-fc9dacc2ca52ee50850c9fdece952464.png";